import BillingView from './Billing.view';
import withNavBar from 'src/hocs/withNavBar.hoc';
import withHelmet from 'src/hocs/withHelmet';
import { withCookies } from 'react-cookie';
import { compose } from 'ramda';
import withProps from 'src/hocs/withProps';
import { t } from 'src/i18n';

const enhance = compose(
  withProps({ title: t('general.title.billing') }),
  withHelmet,
  withCookies,
  withNavBar
);

export default enhance(BillingView);
